import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { EvaluationCriteriaWrapperComponent } from '@/app/components/projects/project-development/tendering/inivitation-to-tender/evaluation-criteria-wrapper/evaluation-criteria-wrapper.component';
import { ProjectBriefComponent } from '@/app/components/projects/project-development/tendering/shared/developer/project-brief/project-brief.component';
import { DomSanitizer } from '@angular/platform-browser';
import { PrintService } from '@/app/services/shared/print.service';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { environment } from '@/app/environments/environment';
import { HttpClient } from '@angular/common/http';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RfpLabelService } from '../rfp-labels.service';

@Component({
  selector: 'app-inivitation-to-tender-view',
  standalone: true,
  imports: [MatRadioModule, CommonModule, ProjectBriefComponent],
  templateUrl: './inivitation-to-tender-view.component.html',
  styleUrl: './inivitation-to-tender-view.component.css',
})
export class InivitationToTenderViewComponent implements OnInit {
  ittId: number;
  responseId: number;
  preInitiationDataResponse: any;
  tenderType: string;
  tendererResponse: any;
  selectedWp: any;
  experience: any;


  docUrl: string = '';
  sitePreparationAttachments = [];
  structuralCivilWorksAttachments = [];
  mepWorksAttachments = [];
  fitoutAttachments = [];
  healthSafetyAttachments = [];
  postConstructionAttachments = [];
  relevantExperienceAttachments = [];
  cvsOfKeyPersonnelsAttachments = [];
  financialStabilityAttachments = [];
  proofOfInsuranceAttachments = [];
  performanceBondsAttachments = [];
  technicalProposalAttachments = [];
  projectProgrammeAttachments = [];
  environmentalSustainabilityPlanAttachments = [];
  technicalDeviationsClarificationsAttachments = [];
  technicalHealthSafetyAttachments = [];
  commercialPriceBreakdownAttachments = [];


  @Output() handleDialog: EventEmitter<any> = new EventEmitter<any>();
  @Input() isEdit: boolean;
  labels: any;
  isRFPorRFQ: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private PrintService: PrintService,
    private TenderingService: TenderingService,
    private http: HttpClient,
    private getFileIconService: GetFileIconUtilityService,
    private router: Router,
    private route: ActivatedRoute,
    private rfpLabelService: RfpLabelService,

  ) { }

  ngOnInit(): void {
    this.route.url.subscribe(() => {
      this.updateRFPorRFQFlag();
      const currentRoute = this.router.url; // Get full URL path
      this.rfpLabelService.updateLabelsFromRoute(currentRoute);
    });
    this.rfpLabelService.labels$.subscribe((labels) => {
      this.labels = labels;
    });
    this.ittId = this.data?.ittId;
    this.responseId = this.data?.responseId;
    this.selectedWp = this.data?.selectedWp;
    this.tenderType = this.data?.tenderType;
    this.experience = JSON.parse(
      this.data?.tendererResponse?.relevant_experience
    );

    // TODO: this and its parent component needs refactoring both on frontend and on backend
    this.getFullResponse()
  }
  updateRFPorRFQFlag() {
    const currentRoute = this.router.url.toLowerCase(); // Get full URL path
    if(currentRoute.includes('rfp')){
      this.isRFPorRFQ = 'RFP';
    }else if(currentRoute.includes('rfq')){
      this.isRFPorRFQ = 'RFQ'
    }
    console.log('isRFPorRFQ:', this.isRFPorRFQ);
  }
  getFileIcon(file: {
    file: File;
    preview: string;
    id?: number;
    name?: string;
  }): string {
    return this.getFileIconService.getFileIcon(file);
  }
  getFullResponse() {
    console.log('getFullResponse getFullResponse getFullResponse');
    
    this.TenderingService.developerViewIttTendererResponse(this.ittId, this.responseId).subscribe({
      next: (response) => {
        if (response?.meta?.success) {
          this.tendererResponse = response?.data;
          this.populateRFPTendererAttachments();
        }
      },
      error: (error) => {
        if (error) {
          console.log(error);
        }
      }
    })
  }

  closeDialog(): void {
    this.dialog.closeAll();
    this.handleDialog.emit();
    this.isEdit = false;
  }
  getSanitizedHtml(description: string) {
    if (!description) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }

  evaluation(currentStep: number) {
    const filteredTendererResponse = {
      tenderer_contact_information:
        this.tendererResponse.tenderer_contact_information,
      tenderer_company_name: this.tendererResponse.tenderer_company_name,
      tenderer_position: this.tendererResponse.tenderer_position,
      tenderer_name: this.tendererResponse.tenderer_name,
    };

    this.dialog.open(EvaluationCriteriaWrapperComponent, {
      width: '78vw',
      height: '80vh',
      maxWidth: 'unset',
      autoFocus: false,
      data: {
        applicantOrgId: this.data?.applicantOrgId,
        ittId: this.ittId,
        responseId: this.responseId,
        tenderResponse: filteredTendererResponse,
        currentStep: currentStep
      },
    });
  }
  rfpPrint() {
    this.PrintService.printContent('InitiateRfp', ' RFP-developer-company-response-view')
    this.closeDialog();
  }

  downloadTendererDocument(
    event: Event,
    downloadLink: HTMLAnchorElement,
    id: number,
    filePath: string
  ): void {
    if (!this.docUrl) {
      event.preventDefault();

      const parts = filePath.split('/');
      const _filePath = parts[parts.length - 1];

      const apiUrl = environment.apiUrl;
      const fullPath = `${apiUrl}/projects/10/tendering/rfp/download/tenderer-documents/${id}/${_filePath}`;
      // const fullPath = `${apiUrl}/projects/${this.projectId}/tendering/rfp/download/tenderer-documents/${id}/${_filePath}`;

      // Fetch the image from the backend
      this.http.get(fullPath, { responseType: 'blob' }).subscribe((blob) => {
        this.docUrl = window.URL.createObjectURL(blob); // Convert blob to URL
        downloadLink.click();
      });
    } else {
      event.preventDefault();
      window.open(this.docUrl, '_blank');
      this.docUrl = null;
    }
  }

  populateRFPTendererAttachments() {
    const attachmentMappings = [
      { key: 'site_preparation_attach', target: 'sitePreparationAttachments' },
      { key: 'structure_civil_attach', target: 'structuralCivilWorksAttachments' },
      { key: 'mep_work_attach', target: 'mepWorksAttachments' },
      { key: 'finishing_fitout_attach', target: 'fitoutAttachments' },
      { key: 'post_construction_attach', target: 'postConstructionAttachments' },
      { key: 'relevant_experience_attach', target: 'relevantExperienceAttachments' },
      { key: 'health_safety_attach', target: 'healthSafetyAttachments' },
      { key: 'financial_stability_attach', target: 'financialStabilityAttachments' },
      { key: 'proof_of_insurance_attach', target: 'proofOfInsuranceAttachments' },
      { key: 'performance_bond_gurantee_attach', target: 'performanceBondsAttachments' },
      { key: 'cvs_of_key_personnel_attach', target: 'cvsOfKeyPersonnelsAttachments' },
      { key: 'technical_proposal_attach', target: 'technicalProposalAttachments' },
      { key: 'project_programme_attach', target: 'projectProgrammeAttachments' },
      { key: 'environmental_sustainability_plan_attach', target: 'environmentalSustainabilityPlanAttachments' },
      { key: 'technical_deviations_clarifications_attach', target: 'technicalDeviationsClarificationsAttachments' },
      { key: 'technical_health_safety_attach', target: 'technicalHealthSafetyAttachments' },
      { key: 'commercial_price_breakdown_attach', target: 'commercialPriceBreakdownAttachments' }
    ];
  
    attachmentMappings.forEach(({ key, target }) => {
      if (this.tendererResponse?.[key]) {
        this[target] = this.tendererResponse[key].map(file => ({
          id: file?.id,
          name: file?.title,
          path: file?.file_path,
        }));
      }
    });
  }  
}
